import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteTagByTagId } from '@arrived/api_v2';
import { Tag, TagId } from '@arrived/models';

import { UseMutationOptions } from '../queries.utils';
import { tagsByCategoryQueryKeyFn, tagsQueryKeyFn } from './tags.keys';

export function useDeleteTagByTagIdMutation(options?: UseMutationOptions<Tag, TagId>) {
  const queryClient = useQueryClient();

  return useMutation((tagId) => deleteTagByTagId(tagId), {
    ...options,
    onSuccess: (data, variables, context) => {
      const { uuid: tagId, category } = data;

      queryClient.invalidateQueries(tagsQueryKeyFn(tagId));

      if (category) {
        queryClient.invalidateQueries(tagsByCategoryQueryKeyFn(category));
      }

      options?.onSuccess?.(data, variables, context);
    },
  });
}
